module.exports = __webpack_public_path__ + "static/img/default.51ec769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.png
// module id = jY2U
// module chunks = 1